import * as React from 'react';
import { t } from '@moovly/i18n';
import { Switch } from '@moovly/ui';
import { ColorPicker } from '@moovly/clients/lib/resources/settings/settings.interfaces';
import { SettingsPanel, useSettingUpdate } from '@moovly/moovly-settings';

const ColorPickerSettings: React.FC = () => {
  const { value: colorPicker, onUpdate } = useSettingUpdate<ColorPicker>('editor_customisation.color_picker');
  const onSelectColor = React.useCallback(() => onUpdate('color'), [onUpdate]);
  const onSelectGreyScale = React.useCallback(() => onUpdate('greyscale'), [onUpdate]);
  const colorChecked = React.useMemo(() => colorPicker === 'color', [colorPicker]);
  const greyScaleChecked = React.useMemo(() => colorPicker === 'greyscale', [colorPicker]);

  return (
    <SettingsPanel title={t('settings.colorPicker.title')}>
      <div className="d-flex align-items-center mb-2">
        <Switch checked={colorChecked} onCheckedChange={onSelectColor} disabled={colorChecked} />
        <span className="ms-2">{t('settings.colorPicker.displayColorPicker')}</span>
      </div>
      <div className="d-flex align-items-center">
        <Switch checked={greyScaleChecked} onCheckedChange={onSelectGreyScale} disabled={greyScaleChecked} />
        <span className="ms-2">{t('settings.colorPicker.displayGreyScale')}</span>
      </div>
    </SettingsPanel>
  );
};
export default ColorPickerSettings;
